<template>
    <div class="model">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>产品管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>产品分类管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-tree size="mini"
                    :load="load"
                    ref="tree"
                    lazy
                    node-key="id"
                    :props="props"
                    :expand-on-click-node="false"
                    :default-expanded-keys="['root']"
                    accordion>
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                        <span style="flex-grow: 1">
                            <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                :content="node.data.description">
                                <span slot="reference"><i v-if="node.data.fid == 'root'" :class="node.data.icon"></i>{{ node.label }}</span>
                            </el-popover>
                        </span>
                        <span style="width: 80px; text-align: center">
                            <el-tag
                                :type="node.data.status ===  1 ? 'primary' : 'info'"
                                disable-transitions>{{node.data.status === 1 ? "有效" : "无效" }}</el-tag>
                        </span>
                        <span style="margin-left: 50px;text-align:right; width: 300px">
                            <el-button
                                type="text"
                                size="mini"
                                @click="handleAdd(node)">添加产品子分类</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button :disabled="node.data.id === 'root'"
                                       size="mini" type="text"
                                @click="handleEdit(node)">编辑信息</el-button>
                            <!-- <el-button :disabled="node.data.id === 'root'"
                                size="mini"
                                type="danger"
                                @click="handleDelete(node)">删除</el-button> -->
                        </span>
                    </div>
                </el-tree>
            </el-card>
        </main>
        <el-dialog title="商品分类" :visible.sync="editDialogVisible" :close-on-click-modal="false"  width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="editForm.description" placeholder="请输入描述" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="editForm.status" placeholder="请选择状态" clearable>
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="editForm.sort" placeholder="请输入排序号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data() {
        return {
            loading: false,
            props: {
                id: "id",
                label: 'name',
                children: 'children',
                isLeaf: 'leaf'
            },
            tableData: [
                {
                    id: "root",
                    fid: "",
                    name: "产品列表",
                    type: 0,
                    status: 1,
                    children: [],
                    hasChildren: true
                }
            ],
            editForm: {
                id: "",
                fid: "",
                name: "",
                description: "",
                status: "1",
                sort: 0,
            },
            currentNode: {},
            editDialogVisible: false,
            canSubmit: true,
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ],
                sort: [
                    { required: true, message: '请输入排序', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        load(node, resolve) {
            if(node.level === 0) {
                resolve([{id: "root", name: "产品列表", type: 0, description: "产品列表", uri: "-", status: 1}])
            } else {
                this.loading = true;
                let _this = this;
                this.$axios.post("/admin/product/category/list", {
                    fid: node.data.id,
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        resolve(resp.data.map(it => ({...it, leaf: (it.children || []).length === 0})));
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                    _this.loading = false;
                }).catch(function(error) {
                    _this.loading = false;
                });
            }
        },
        handleAdd(node) {
            let data = node.data;
            this.editForm = {
                id: "",
                icon: "",
                fid: data.id,
                name: "",
                type: "0",
                description: "",
                uri: "",
                status: "1",
                sort: 0,
            }
            this.currentNode = node;
            this.canSubmit = true;
            this.editDialogVisible = true;
        },
        handleEdit(node) {
            let data = node.data;
            if(data.id == "root") {
                this.$notify({
                    title: '提示',
                    message: '这条不能修改',
                    type: 'warning'
                });
                return;
            }
            this.editForm = {
                id: data.id,
                icon: data.icon,
                fid: data.fid,
                name: data.name,
                type: data.type + "",
                description: data.description,
                uri: data.uri,
                status: data.status + "",
                sort: data.sort,
            }
            this.currentNode = node;
            this.canSubmit = true;
            this.editDialogVisible = true;
        },
        handleDelete(node) {
            let _this = this;
            if(node.data.id == "root") {
                this.$notify({
                    title: '提示',
                    message: '这条不能删除',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('是否删除分类【' + node.data.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/product/category/delete/" + node.data.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.$refs.tree.remove(node);
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        onSubmit() {
            if(this.canSubmit) {
                this.canSubmit = false;
                let that = this;
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$axios.post("/admin/product/category", this.editForm)
                        .then(function(response) {
                            let msg = '数据添加成功';
                            let resp = response.data;
                            if(resp.header.status == 0) {

                                let parent = null;
                                if(that.editForm.id == "") {
                                    msg = '数据添加成功';
                                    parent = that.currentNode;
                                } else {
                                    msg = '数据修改成功';
                                    let node = that.$refs.tree.getNode(resp.data.id);
                                    parent = node.parent;
                                    that.$refs.tree.remove(node);
                                }
                                that.$notify({
                                    title: '成功',
                                    message: msg,
                                    type: 'success'
                                });

                                let baseNode = undefined;
                                for(let i=parent.childNodes.length-1; i>=0; i--) {
                                    if(resp.data.sort < parent.childNodes[i].data.sort) {
                                        baseNode = parent.childNodes[i];
                                    } else {
                                        break;
                                    }
                                }
                                if(baseNode === undefined) {
                                    that.$refs.tree.append(resp.data, parent);
                                } else {
                                    that.$refs.tree.insertBefore(resp.data, baseNode);
                                }
                                that.editDialogVisible = false;
                            }
                        })
                    }
                });
            }
        },
        handleClose() {},
    },
    created() {
    },
}
</script>
<style>
.custom-tree-node {
    display: flex;
    width: 100%;
    height: 48px;
    line-height: 48px;
}
.el-tree-node__content {
    height: 48px !important;
}
</style>
